import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "text-lg text-left" }
const _hoisted_2 = { class: "w-4 h-4 text-neutral-400 ml-8 flex-shrink-0" }
const _hoisted_3 = { class: "h-0 px-4 pb-4 overflow-hidden" }
const _hoisted_4 = { class: "" }

import { Disclosure, DisclosureButton } from "@headlessui/vue";
import { MinusIcon, PlusIcon } from "@heroicons/vue/24/solid";
import { gsap } from "gsap";

export default /*#__PURE__*/_defineComponent({
  __name: 'DisclosureItem',
  setup(__props) {

const toggle = (el: HTMLElement, height: string) =>
    gsap.to(el, { height, duration: 0.1, ease: "power3.out" });
const onEnter = async (el: HTMLElement, done: any) =>
    toggle(el, "auto").then(done);
const onLeave = async (el: HTMLElement, done: any) =>
    toggle(el, "0").then(done);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Disclosure), {
    as: "div",
    class: "w-full border border-neutral-800 rounded"
  }, {
    default: _withCtx(({ open }) => [
      _createVNode(_unref(DisclosureButton), { class: "flex items-center justify-between w-full cursor-pointer p-4" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _renderSlot(_ctx.$slots, "question")
          ]),
          _createElementVNode("div", _hoisted_2, [
            open
              ? (_openBlock(), _createBlock(_unref(MinusIcon), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(PlusIcon), { key: 1 }))
          ])
        ]),
        _: 2
      }, 1024),
      _createVNode(_Transition, {
        onEnter: onEnter,
        onLeave: onLeave,
        css: false
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "answer")
            ])
          ], 512), [
            [_vShow, open]
          ])
        ]),
        _: 2
      }, 1024)
    ]),
    _: 3
  }))
}
}

})